import { render, staticRenderFns } from "./notification.transfert.vue?vue&type=template&id=151433b3&"
import script from "./notification.transfert.vue?vue&type=script&lang=js&"
export * from "./notification.transfert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports